import { useState } from "react";
import { CommentForm } from "./CommentForm";
import { CommentListItemView } from "./CommentListItemView";

export const CommentListItem = ({ comment, type, root, readOnly = false}) => {
    const [reply, setReply] = useState(false);
    const [modify, setModify] = useState(false);

    // 답글폼을 토글
    const onToggleReply = () => {
        setReply(!reply);
        setModify(reply ? modify : false);
    }

    // 수정 창을 토글
    const onToggleModify = () => {
        setModify(!modify);
        setReply(modify ? reply : false);
    }

    if (comment === null) return null;

    return (
        <CommentListItemView comment={comment} root={root} type={type} readOnly={readOnly} onReplyForm={onToggleReply} onModifyForm={onToggleModify}>
            {!readOnly && reply && (
                <CommentForm className="reply_write input_wrap _edit cancel_form"
                    type={type} root={root}
                    onCancel={onToggleReply}
                    mode="reply"
                    comment={comment}
                    useCancel={true}
                />
            )}
            {!readOnly && modify && (
                <CommentForm className="reply_write input_wrap _edit cancel_form"
                    type={type} root={root}
                    onCancel={onToggleModify}
                    useCancel={true}
                    mode="modify"
                    comment={comment}
                />
            )}
        </CommentListItemView>
    );
};